import { shallowMount } from "@vue/test-utils";
import ThankYouOtp from "@/views/ThankYouOtp";

describe("ThankYouOtp component", () => {
  let wrapper;

  beforeEach(() => {
    wrapper = shallowMount(ThankYouOtp);
  });

  it("Renders del component ThankYouOtp", () => {
    expect(wrapper).toBeDefined();
  });
});
